import React, { Component } from 'react'
import { pink, green, maxwidth } from '../../constants'
import teams from '../../images/teams.png'
import Teams_slider from '../Teams_slider/Teams_slider'
import { useEffect, useState, useRef, dataRef, useCallback } from 'react'
import './Teams.css'
import { useSpring, animated } from "react-spring"
import TypewriterComponent from 'typewriter-effect'


function Number({ n }) {
    const { number } = useSpring({
        from: { number: 0 },
        number: n,
        delay: 200,
        loop: true,
        config: { mass: 1, tension: 20, friction: 10 }
    });
    return <animated.div>{number.to((n) => n.toFixed(0))}</animated.div>
}



export default function Teams() {


    const [{ scroll }, set] = useSpring(() => ({ scroll: 0 }))
    const onScroll = useCallback((e) => void set({ scroll: e.target.scrollTop / (window.innerHeight / 2) }), [])

    return (
        <div id='teams' className='team-outer-container'>
            <p className='title'>Teams</p>
            <div className='team-inner-container'>
                <div className='team-subone-hidden' >
                    <span style={{ textAlign: "center", padding: "0px" }}>Empowerers coming<br />
                        from all over India<br />
                        <span style={{ color: green, fontSize: "25px", fontWeight: "bold" }}><div style={{ display: "flex", flexdirection: "row", alignItems: "center", justifyContent: "center" }}><Number n={15}></Number>+ States</div></span></span>

                    <div ><img src={teams} width="100%" ></img></div>
                    <span style={{ textAlign: "center", height: "150px" }}> <TypewriterComponent style={{ textAlign: "center" }} options={{
                        autoStart: true,
                        loop: true,

                        strings: [
                            "We are not a team<br/> because we work together.<br/>We are a team because we <br/>respect, trust, and care for<br/> each other.",
                        ]
                    }}></TypewriterComponent></span>
                </div>

                <div className='team-subone'>



                    <div className='team-subone-subcontainer' >
                        <span style={{ textAlign: "center" }}>Empowerers coming<br />
                            from all over India<br />
                            <span style={{ color: green, fontSize: "25px", fontWeight: "bold" }}><div style={{ display: "flex", flexdirection: "row", alignItems: "center", justifyContent: "center" }}><Number n={15}></Number>+ States</div></span></span>


                        <span style={{ textAlign: "center", height: "100px" }}> <TypewriterComponent style={{ textAlign: "center" }} options={{
                            autoStart: true,
                            loop: true,

                            strings: [
                                "We are not a team<br/> because we work<br/> together. We are a team<br/> because we respect, trust,<br/> and care for each other.",
                            ]
                        }}></TypewriterComponent></span>


                    </div>

                    <div ><img src={teams} width="90%" ></img></div>

                </div>
                <div className='team-subtwo'>

                    <span style={{ color:pink, fontSize: "25px", fontWeight: "bold", marginTop: "20px" }}><div style={{ display: "flex", flexdirection: "row", alignItems: "center", justifyContent: "center" }}>Empowerers</div></span>
                    <span style={{ textAlign: "center", marginBottom: "30px" }}>What They Say About Us?</span>

                    <Teams_slider></Teams_slider>

                </div>
            </div>
        </div>
    )

}


